export { default } from './SimilarTitlesUGCEditor';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/SimilarTitlesUGCEditor/index.js